/** TanStack Query hook for the attention (Home) summary (UX spec §3.8). */

import { useQuery } from '@tanstack/react-query'
import { getAttentionSummary } from '../api/attention.ts'

export function useAttentionSummary() {
  return useQuery({
    queryKey: ['attention', 'summary'],
    queryFn: getAttentionSummary,
    // Matches the SERVER's 60 s TTL (services/attention_cache.py). This layer
    // only saves this tab a round-trip; the server-side cache is what stops
    // every tab and every operator re-running the per-feeder voltage loop.
    staleTime: 60_000,
  })
}
